/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ManualRequestBuilderRequestsMetadata, type ManualRequestBuilder } from './manual/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /ingests/chargepoint-consumption
 */
export interface ChargepointConsumptionRequestBuilder extends BaseRequestBuilder<ChargepointConsumptionRequestBuilder> {
    /**
     * The manual property
     */
    get manual(): ManualRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ChargepointConsumptionRequestBuilderUriTemplate = "{+baseurl}/ingests/chargepoint-consumption";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ChargepointConsumptionRequestBuilderNavigationMetadata: Record<Exclude<keyof ChargepointConsumptionRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    manual: {
        requestsMetadata: ManualRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
